export enum NumberType {
    Default = 0,
    Currency = 1,
    Percentage = 2
}
